import React from 'react';
import { Router } from './components';

const BootStrap: React.FC = () => {
    return <Router />;
};

export default BootStrap;
